import { gql } from '@apollo/client';
import { PriceListPricesFragment, PriceListSummaryFragment } from '../fragments/PriceListFragment';
/**
 * @const PriceListsQuery
 * @since 1.0.0
 */
export const PriceListsQuery = gql `
  query PriceListsQuery($input: PriceListsInput) {
    priceLists(input: $input) {
      ...PriceListSummaryFragment
    }
  }

  ${PriceListSummaryFragment}
`;
/**
 * Active lists with their prices, for the deal and agreement pickers.
 * @const PriceListPricesQuery
 * @since 1.0.0
 */
export const PriceListPricesQuery = gql `
  query PriceListPricesQuery($input: PriceListsInput) {
    priceLists(input: $input) {
      ...PriceListPricesFragment
    }
  }

  ${PriceListPricesFragment}
`;
